export const GENERIC_ERROR_MESSAGE =
  'Something failed. Please, try again later.'
